export const AUTH_TYPE = {
  MICROSOFT: 'MICROSOFT', // passport-saml, saml1
  SAML: 'SAML', // smalify
};
